import Switch from './src/index.vue'

export default Switch
